<template>
  <SButton
    v-if="items.length === 1"
    class="company-wall-product-select__button"
    color="accent"
    :to="buildProductUrl(items[0]!.value)"
  >
    {{ tr("main_site.company_wall.cta.open_direct_match_form") }}
  </SButton>
  <form
    v-else
    class="company-wall-product-select"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <SSelect
      v-model="selectedProduct"
      class="company-wall-product-select__select"
      :items
      :label="tr('main_site.company_wall.cta.product_select_label')"
      :loading="loading"
      name="products"
      :placeholder="tr('main_site.company_wall.cta.product_select_placeholder')"
      required
      :rules="[
        required(undefined, {
          message: () =>
            tr('main_site.company_wall.cta.product_select_required'),
        }),
      ]"
      show-required-type="none"
      @update:model-value="onProductRedirect"
    />
    <SButton
      class="company-wall-product-select__button"
      color="accent"
      type="submit"
    >
      {{ tr("main_site.company_wall.cta.open_direct_match_form") }}
    </SButton>
  </form>
</template>

<script setup lang="ts">
import { navigateTo } from "#app";
import { computed, ref } from "vue";

import { SButton, SSelect } from "@solvari/common-fe";
import { required, useValidationObserver } from "@solvari/common-fe/validation";
import { useI18nMainSiteCompanyWall } from "@solvari/translations";

import { ziggy } from "@/shared/libs/ziggy";

const props = defineProps<{
  customerId: number;
  geoProductCategories: App.Data.CompanyWall.CompanyWallProductWithEndProductsData[];
}>();

const { tr } = useI18nMainSiteCompanyWall();
const { validateAll } = useValidationObserver();

const loading = ref(false);

const items = computed(() =>
  props.geoProductCategories.map((geoProductCategory) => ({
    value: geoProductCategory.slug,
    label: geoProductCategory.name,
  })),
);

const selectedProduct = ref<number | string | null>(
  items.value.length === 1 ? items.value[0]!.value : null,
);

function buildProductUrl(geoProductSlug: string): string {
  return ziggy(
    "mainSite.geoProduct.leadForm",
    { formSlug: undefined, geoProductSlug },
    { customerId: props.customerId },
  );
}

function onProductRedirect(geoProductSlug: unknown) {
  loading.value = true;
  void navigateTo(buildProductUrl(String(geoProductSlug)));
}

async function handleSubmit() {
  if (!(await validateAll())) {
    return;
  }
  if (selectedProduct.value) {
    onProductRedirect(selectedProduct.value);
  }
}
</script>

<style lang="postcss">
.company-wall-product-select {
  &__select {
    @apply mb-4;
  }
  &__button {
    @apply w-full;
  }
}
</style>
